import { calendarDayOrdinal } from '@app/shared/ui/timeline/timeline-days.util';

/** Date controls represent the selected calendar day, not a UTC instant. */
export function scheduleControlDay(value: Date): string {
  if (!(value instanceof Date) || !Number.isFinite(value.getTime())) throw new Error('Invalid date control');
  return `${String(value.getFullYear()).padStart(4, '0')}-${String(value.getMonth() + 1).padStart(2, '0')}-${String(value.getDate()).padStart(2, '0')}`;
}
export function scheduleDayControl(day: string | null): Date | null {
  if (day === null) return null;
  calendarDayOrdinal(day);
  const [year, month, date] = day.split('-').map(Number);
  const result = new Date(0);
  result.setFullYear(year, month - 1, date);
  result.setHours(12, 0, 0, 0);
  return result;
}
export function schedulePeriod(anchor: string, mode: 'week' | 'month'): { from: string; to: string } {
  const day = calendarDayOrdinal(anchor);
  const date = new Date(day * 86_400_000);
  const from = mode === 'week' ? day - ((date.getUTCDay() + 6) % 7) : day - date.getUTCDate() + 1;
  const monthEnd = new Date(day * 86_400_000);
  monthEnd.setUTCMonth(date.getUTCMonth() + 1, 0);
  const to = mode === 'week' ? from + 6 : Math.floor(monthEnd.getTime() / 86_400_000);
  return {
    from: new Date(from * 86_400_000).toISOString().slice(0, 10),
    to: new Date(to * 86_400_000).toISOString().slice(0, 10)
  };
}
